import { useContext, useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { MessageContext } from "../context/MessageContext";

function ProfileUpdate() {
  const navigate = useNavigate();

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");

  const { showMessage } = useContext(MessageContext);

  const token = localStorage.getItem("token");
  const storedUser = localStorage.getItem("user");

  useEffect(() => {
    if (storedUser) {
      const parsedUser = JSON.parse(storedUser);
      setName(parsedUser.name);
      setEmail(parsedUser.email);
    }
  }, []);
  const API_URL = process.env.REACT_APP_API_URL;
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    const res = await fetch(
      `${API_URL}/updateProfile`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
      },
      body: JSON.stringify({ name, email, currentPassword, newPassword, confirmPassword }),
    });

    const data = await res.json();
    console.log(data.message);

    if (data.success === true) {
      localStorage.setItem("user", JSON.stringify(data.user));
      showMessage(data.message, "success");
      navigate("/profile");
    } else {
      showMessage(data.message, "danger");
      navigate("/profile-update");
    }
  }
  return (
    <>
      <div style={{ marginBottom: '50px' }}></div>
      <div className="page-title">
        <nav className="breadcrumbs">
          <div className="container">
            <ol>
              <li><NavLink to="/">Home</NavLink></li>
              <li><NavLink to="/profile">Profile-detail</NavLink></li>
              <li className="current">Profile-Update</li>
            </ol>
          </div>
        </nav>
      </div>
      <section className="section">
        <div className="container">
          <div className="row justify-content-center">

            <div className="col-lg-5 col-md-7">
              <div className="card shadow-sm">
                <div className="card-body p-4">

                  <h4 className="text-center mb-4">
                    <i className="bi bi-person-circle me-2"></i>
                    Profile Update
                  </h4>

                  <form onSubmit={handleSubmit}>
                    <div className="mb-3">
                      <label className="form-label">Name</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter name" value={name} onChange={(e) => setName(e.target.value)}
                        required
                      />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Email</label>
                      <input
                        type="email"
                        className="form-control"
                        placeholder="Enter email" value={email} onChange={(e) => setEmail(e.target.value)}
                        required
                      />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Current Password</label>
                      <input
                        type="password"
                        className="form-control"
                        placeholder="Enter current password" value={currentPassword} onChange={(e) => setCurrentPassword(e.target.value)}
                        required
                      />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">New Password</label>
                      <input
                        type="password"
                        className="form-control"
                        placeholder="Enter new password" value={newPassword} onChange={(e) => setNewPassword(e.target.value)}
                        required
                      />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Confirm Password</label>
                      <input
                        type="password"
                        className="form-control"
                        placeholder="Enter confirm password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)}
                        required
                      />
                    </div>

                    <div className="d-grid">
                      <button type="submit" className="btn btn-primary">
                        Submit
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>
    </>
  );
}

export default ProfileUpdate;
